import { useNavigationAudioControl } from '@/hooks/useNavigationAudioControl';

/**
 * Component that listens to navigation changes and auto-pauses audio
 * Also handles tab visibility changes
 */
export const NavigationAudioListener = () => {
  useNavigationAudioControl();
  return null;
};
